var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPicoLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 1",
    clipPath: "url(#clip0_4307_39002)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.6668 13.642C14.6676 13.9131 14.5275 14.1733 14.2775 14.3654C14.0275 14.5576 13.688 14.666 13.3335 14.6668H2.66683C2.49126 14.6666 2.31749 14.6398 2.15544 14.5882C1.99338 14.5365 1.84624 14.4609 1.72241 14.3657C1.59858 14.2706 1.50049 14.1576 1.43376 14.0335C1.36703 13.9093 1.33296 13.7763 1.3335 13.642V2.35833C1.33314 2.22402 1.36738 2.09098 1.43426 1.96679C1.50114 1.8426 1.59935 1.72969 1.72329 1.63453C1.84723 1.53936 1.99447 1.4638 2.1566 1.41215C2.31872 1.3605 2.49257 1.33377 2.6682 1.3335L13.3349 1.34709C13.6891 1.3482 14.0283 1.45673 14.278 1.64886C14.5277 1.841 14.6676 2.10104 14.6668 2.37193V13.642Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M30.6668 12.7665C30.6643 13.2738 30.5224 13.7589 30.2724 14.1153C30.0224 14.4716 29.6847 14.6699 29.3335 14.6668H18.6668C18.4929 14.6686 18.3204 14.6209 18.1592 14.5263C17.998 14.4318 17.8513 14.2923 17.7275 14.1158C17.6037 13.9394 17.5051 13.7294 17.4375 13.4978C17.3699 13.2663 17.3346 13.0178 17.3335 12.7665V3.25946C17.3357 2.75268 17.477 2.26788 17.7265 1.91157C17.976 1.55526 18.3132 1.3566 18.6641 1.35923L29.3308 1.33355C29.6823 1.32986 30.0205 1.52794 30.2711 1.88425C30.5216 2.24056 30.6639 2.72595 30.6668 3.23378V12.7665Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 57",
    d: "M23.6637 5.48685C23.7949 5.28238 24.0937 5.28238 24.2248 5.48685L26.5017 9.03617C26.644 9.25802 26.4847 9.54949 26.2212 9.54949H21.6674C21.4038 9.54949 21.2445 9.25802 21.3868 9.03617L23.6637 5.48685Z",
    fill: "#FF9C2B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 57_2",
    d: "M7.6637 26.5132C7.79487 26.7176 8.09367 26.7176 8.22483 26.5132L10.5017 22.9638C10.644 22.742 10.4847 22.4505 10.2212 22.4505H5.66737C5.4038 22.4505 5.24449 22.742 5.38681 22.9638L7.6637 26.5132Z",
    fill: "#55B8F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14.6668 28.7606C14.6658 29.0125 14.6303 29.2616 14.5626 29.4937C14.4949 29.7258 14.3962 29.9364 14.2721 30.1134C14.148 30.2904 14.0011 30.4304 13.8395 30.5253C13.678 30.6203 13.5051 30.6684 13.3308 30.6668L2.66409 30.6411C2.31288 30.6432 1.97546 30.4438 1.72596 30.0868C1.47647 29.7297 1.33531 29.2442 1.3335 28.7369V19.2377C1.33439 18.9862 1.3696 18.7374 1.43711 18.5055C1.50462 18.2737 1.6031 18.0633 1.72693 17.8865C1.85076 17.7096 1.99751 17.5697 2.15878 17.4749C2.32006 17.38 2.4927 17.332 2.66683 17.3335H13.3335C13.6851 17.3309 14.023 17.53 14.273 17.887C14.523 18.2441 14.6647 18.7299 14.6668 19.2377V28.7606Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M18.6682 30.6668C18.4925 30.6666 18.3185 30.6398 18.1563 30.5881C17.9941 30.5364 17.8468 30.4607 17.7228 30.3654C17.5989 30.2701 17.5007 30.1571 17.4339 30.0328C17.3671 29.9085 17.333 29.7753 17.3335 29.6409V18.3594C17.333 18.2251 17.367 18.092 17.4337 17.9678C17.5005 17.8435 17.5985 17.7305 17.7223 17.6353C17.8461 17.54 17.9933 17.4643 18.1553 17.4125C18.3174 17.3608 18.4912 17.3339 18.6668 17.3335H29.3335C29.5091 17.3339 29.6829 17.3608 29.845 17.4125C30.0071 17.4643 30.1542 17.54 30.278 17.6353C30.4018 17.7305 30.4999 17.8435 30.5666 17.9678C30.6333 18.092 30.6674 18.2251 30.6668 18.3594V29.6274C30.6676 29.8983 30.5278 30.1585 30.2781 30.3508C30.0284 30.5431 29.6892 30.6519 29.3349 30.6532L18.6682 30.6668Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2756",
    x: 21.3335,
    y: 21.3335,
    width: 5.33333,
    height: 5.33333,
    rx: 0.333333,
    fill: "#C30B31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M8.00016 10.6668C9.47292 10.6668 10.6668 9.47292 10.6668 8.00016C10.6668 6.5274 9.47292 5.3335 8.00016 5.3335C6.5274 5.3335 5.3335 6.5274 5.3335 8.00016C5.3335 9.47292 6.5274 10.6668 8.00016 10.6668Z",
    fill: "#07CC9E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4307_39002"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicoLogo);
export default __webpack_public_path__ + "static/media/pico-logo.be143ac008fd26ca3b7196f68fbbff5f.svg";
export { ForwardRef as ReactComponent };